<dx-data-grid biz-grid [selection]='{ mode: "multiple" }' [dataSource]='items' [bizSetSummary]="false"
    (onRowDblClick)="onRowDblClick($event)" (onSelectionChanged)="selectionChanged($event)">

    <dxo-editing [allowUpdating]="false" [allowAdding]="false" [allowDeleting]="false">
    </dxo-editing>

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column dataField="IsEnabled" caption="Alert Enabled" dataType="boolean">
    </dxi-column>

    <dxi-column dataField="PartnerInName" caption="From Partner" dataType="string">
    </dxi-column>

    <dxi-column dataField="PartnerOutName" caption="To Partner" dataType="string">
    </dxi-column>

    <dxi-column dataField="DocumentType" caption="Document Type" dataType="string">
    </dxi-column>

    <dxi-column dataField="LatestDocumentDate" caption="Last Activity" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction">
    </dxi-column>

    <dxi-column dataField="LatestAlertStatusDate" caption="Last Alert Notification" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction">
    </dxi-column>

    <dxi-column dataField="LatestAlertStatus" caption="Alert Status" dataType="string" cellTemplate="alertStatusTemplate" alignment="center">
    </dxi-column>

    <dxi-column caption="Notifications" dataType="string" cellTemplate="notificationTypeTemplate" alignment="center">
    </dxi-column>

    <dxi-column caption="Alert History" dataType="string" cellTemplate="showHistoryTemplate">
    </dxi-column>

    <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(items, 'CreatedBy'))"></dxo-header-filter></dxi-column>
    <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
    <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(items, 'UpdatedBy'))"></dxo-header-filter></dxi-column>
    <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

    <dxi-column type="buttons">
        <dxi-button name="editAlertConfig" template="editAlertConfigurationTemplate"></dxi-button>
        <dxi-button text="Show Log" template="logTemplate"></dxi-button>
        <ng-container *dxTemplate="let cell of 'logTemplate'">
            <app-change-log-link [title]="'Log for alert configuration'" [showIcon]="false" classNames="dx-link">
                <app-change-log-link-entity type="AlertConfiguration" [id]="cell.data.AlertConfigurationId"></app-change-log-link-entity>
            </app-change-log-link>
        </ng-container>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'alertStatusTemplate'">
        <app-status-traffic-light [status]="cell.data.LatestAlertStatus" [tooltip]="alertStatusTooltip(cell.data.LatestAlertStatus)"></app-status-traffic-light>
    </ng-container>

    <ng-container *dxTemplate="let cell of 'notificationTypeTemplate'">
        <app-notification-type-viewer [notifyStakeholder]="cell.data.NotifyStakeholder" [isUrgent]="cell.data.IsUrgent" [notifySender]="cell.data.NotifySender" [notifyReceiver]="cell.data.NotifyReceiver"></app-notification-type-viewer>
    </ng-container>

    <ng-container *dxTemplate="let cell of 'editAlertConfigurationTemplate'">
        <a [routerLink]="['/distribution/result/details', {distributionIds: cell.data.DistributionId}]" class="dx-link custom-button-spacer">Edit</a>
    </ng-container>

    <ng-container *dxTemplate="let cell of 'showHistoryTemplate'">
        <a (click)="showHistoryDialog(cell.data.AlertConfigurationId)" role="button">Show History</a>
    </ng-container>

</dx-data-grid>
